import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bbbc0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container order-history"
}
const _hoisted_2 = {
  key: 0,
  class: "order-history-table"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "overflow-ellipsis" }
const _hoisted_10 = { class: "button-cell" }
const _hoisted_11 = { class: "button-cell__row" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "button-cell__row" }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = { class: "ordercard" }
const _hoisted_16 = { class: "ordercard__row" }
const _hoisted_17 = { class: "ordercard__header" }
const _hoisted_18 = { class: "ordercard__value" }
const _hoisted_19 = {
  key: 0,
  class: "ordercard__row"
}
const _hoisted_20 = { class: "ordercard__header" }
const _hoisted_21 = {
  key: 0,
  class: "ordercard__value"
}
const _hoisted_22 = {
  key: 1,
  class: "ordercard__value"
}
const _hoisted_23 = {
  key: 1,
  class: "ordercard__row"
}
const _hoisted_24 = { class: "ordercard__header" }
const _hoisted_25 = { class: "ordercard__value" }
const _hoisted_26 = { class: "ordercard__row" }
const _hoisted_27 = { class: "ordercard__header" }
const _hoisted_28 = { class: "ordercard__value" }
const _hoisted_29 = { class: "ordercard__row" }
const _hoisted_30 = { class: "ordercard__header" }
const _hoisted_31 = { class: "ordercard__value" }
const _hoisted_32 = {
  key: 2,
  class: "ordercard__row"
}
const _hoisted_33 = { class: "ordercard__header" }
const _hoisted_34 = { class: "ordercard__value overflow-ellipsis" }
const _hoisted_35 = { class: "ordercard__row" }
const _hoisted_36 = { class: "ordercard__button" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "ordercard__button" }
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = {
  key: 1,
  style: {"margin-top":"2rem","padding-left":"20px"}
}
const _hoisted_41 = { class: "show-order-table" }
const _hoisted_42 = { class: "summary-head" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { class: "summary-body" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { key: 4 }
const _hoisted_53 = { class: "orders-head" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { class: "orders-body" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { key: 3 }
const _hoisted_62 = { key: 4 }
const _hoisted_63 = { key: 5 }
const _hoisted_64 = { key: 6 }
const _hoisted_65 = { class: "message-summary-row" }
const _hoisted_66 = {
  class: "message",
  colspan: "3"
}
const _hoisted_67 = { class: "order-summary-row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_71 = { class: "button-wrapper" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_76 = { class: "show-order-card" }
const _hoisted_77 = { class: "card-container" }
const _hoisted_78 = { class: "ordercard" }
const _hoisted_79 = { class: "ordercard__row" }
const _hoisted_80 = { class: "ordercard__header" }
const _hoisted_81 = { class: "ordercard__value" }
const _hoisted_82 = {
  key: 0,
  class: "ordercard__row"
}
const _hoisted_83 = { class: "ordercard__header" }
const _hoisted_84 = {
  key: 0,
  class: "ordercard__value"
}
const _hoisted_85 = {
  key: 1,
  class: "ordercard__value"
}
const _hoisted_86 = {
  key: 1,
  class: "ordercard__row"
}
const _hoisted_87 = { class: "ordercard__header" }
const _hoisted_88 = { class: "ordercard__value" }
const _hoisted_89 = { class: "ordercard__row" }
const _hoisted_90 = { class: "ordercard__header" }
const _hoisted_91 = { class: "ordercard__value" }
const _hoisted_92 = { class: "ordercard__row" }
const _hoisted_93 = { class: "ordercard__header" }
const _hoisted_94 = { class: "ordercard__value" }
const _hoisted_95 = { class: "ordercard" }
const _hoisted_96 = { class: "ordercard__row" }
const _hoisted_97 = { class: "ordercard__header" }
const _hoisted_98 = { class: "ordercard__value" }
const _hoisted_99 = {
  key: 0,
  class: "ordercard__row"
}
const _hoisted_100 = { class: "ordercard__header" }
const _hoisted_101 = { class: "ordercard__value" }
const _hoisted_102 = {
  key: 1,
  class: "ordercard__row"
}
const _hoisted_103 = { class: "ordercard__header" }
const _hoisted_104 = { class: "ordercard__value" }
const _hoisted_105 = {
  key: 2,
  class: "ordercard__row"
}
const _hoisted_106 = { class: "ordercard__header" }
const _hoisted_107 = { class: "ordercard__value" }
const _hoisted_108 = {
  key: 3,
  class: "ordercard__row"
}
const _hoisted_109 = { class: "ordercard__header" }
const _hoisted_110 = { class: "ordercard__value" }
const _hoisted_111 = {
  key: 4,
  class: "ordercard__row"
}
const _hoisted_112 = { class: "ordercard__header" }
const _hoisted_113 = { class: "ordercard__value" }
const _hoisted_114 = { class: "ordercard__row" }
const _hoisted_115 = { class: "ordercard__header" }
const _hoisted_116 = { class: "ordercard__value" }
const _hoisted_117 = { class: "order-summary" }
const _hoisted_118 = {
  key: 0,
  class: "ordermessage-container"
}
const _hoisted_119 = { class: "description" }
const _hoisted_120 = { class: "value" }
const _hoisted_121 = { class: "button-wrapper" }
const _hoisted_122 = {
  key: 1,
  class: "loader-wrapper"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_124 = [
  _hoisted_123
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomPagination = _resolveComponent("CustomPagination")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showHistory)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.noResults)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.OrderDate")), 1),
                          (_ctx.isContract || _ctx.isReseller)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_3, _toDisplayString(_ctx.$t("OrderHistory.Recipient")), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isContract || _ctx.isReseller)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_ctx.$t("OrderHistory.City")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Number")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Status")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Message")), 1),
                          _hoisted_5
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history?.items, (order) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: order.externalId
                          }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.formatDate(order.orderDate)), 1),
                            (_ctx.isReseller)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(order.shipTo.customer.firstName + " " + order.shipTo.customer.lastName), 1))
                              : _createCommentVNode("", true),
                            (_ctx.isContract)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(order.sellTo.company.name), 1))
                              : _createCommentVNode("", true),
                            (_ctx.isContract || _ctx.isReseller)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(order.shipTo.address.city), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, _toDisplayString(order.orderNo), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t("OrderStatus." + order.status)), 1),
                            _createElementVNode("td", _hoisted_9, _toDisplayString(order.info.find(infoType => infoType.code =="orderComment")?.value), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.showOrder(order)),
                                    class: "button--small button--primary"
                                  }, _toDisplayString(_ctx.$t("Common.Show")), 9, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.orderAgain(order)),
                                    class: "button--small button--primary order-again-button",
                                    disabled: _ctx.processing
                                  }, _toDisplayString(_ctx.$t("OrderHistory.OrderAgain")), 9, _hoisted_14)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history?.items, (order) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-container",
                  key: order.externalId
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("OrderHistory.OrderDate")), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$filters.formatDate(order.orderDate)), 1)
                    ]),
                    (_ctx.isContract || _ctx.isReseller)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("OrderHistory.Recipient")), 1),
                          (_ctx.isReseller)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(order.shipTo.customer.firstName + " " +
              order.shipTo.customer.lastName), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isContract)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(order.sellTo.company.name), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isContract || _ctx.isReseller)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("OrderHistory.City")), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(order.shipTo.address.city), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("OrderHistory.Number")), 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(order.orderNo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("OrderHistory.Status")), 1),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("OrderStatus." + order.status)), 1)
                    ]),
                    (order.info.find(infoType => infoType.code == 'orderComment'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("OrderHistory.Message")), 1),
                          _createElementVNode("div", _hoisted_34, _toDisplayString(order.info.find(infoType => infoType.code =="orderComment")?.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button--small button--primary",
                          onClick: ($event: any) => (_ctx.showOrder(order))
                        }, _toDisplayString(_ctx.$t("Common.Show")), 9, _hoisted_37)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button--small button--primary",
                          onClick: ($event: any) => (_ctx.orderAgain(order)),
                          disabled: _ctx.processing
                        }, _toDisplayString(_ctx.$t("OrderHistory.OrderAgain")), 9, _hoisted_39)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.noResults)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_40, "Inget resultat från söket"))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_component_CustomPagination, {
                pagination: _ctx.pagination,
                key: _ctx.paginationKey,
                onOnPaginationClick: _ctx.onPaginationClick
              }, null, 8, ["pagination", "onOnPaginationClick"]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.order)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", _hoisted_42, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.OrderDate")), 1),
                      (_ctx.isContract || _ctx.isReseller)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_43, _toDisplayString(_ctx.$t("OrderHistory.Recipient")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isContract || _ctx.isReseller)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_44, _toDisplayString(_ctx.$t("OrderHistory.City")), 1))
                        : _createCommentVNode("", true),
                      (!(_ctx.isContract || _ctx.isReseller))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_45))
                        : _createCommentVNode("", true),
                      (!(_ctx.isContract || _ctx.isReseller))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_46))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Number")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Status")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_47, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.formatDate(_ctx.order.orderDate)), 1),
                      (_ctx.isContract)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_48, _toDisplayString(_ctx.order.sellTo.company.name), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isReseller)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_49, _toDisplayString(_ctx.order.shipTo.customer.firstName + " " + _ctx.order.shipTo.customer.lastName), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isContract || _ctx.isReseller)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(_ctx.order.shipTo.address.city), 1))
                        : _createCommentVNode("", true),
                      (!(_ctx.isContract || _ctx.isReseller))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_51))
                        : _createCommentVNode("", true),
                      (!(_ctx.isContract || _ctx.isReseller))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_52))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, _toDisplayString(_ctx.order.orderNo), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("OrderStatus." + _ctx.order.status)), 1)
                    ])
                  ]),
                  _createElementVNode("thead", _hoisted_53, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.ProductOrder")), 1),
                      (_ctx.isReseller)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_54, _toDisplayString(_ctx.$t("OrderHistory.ProductSize")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isContract)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_55))
                        : _createCommentVNode("", true),
                      (!(_ctx.isContract || _ctx.isReseller))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_56))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.Amount")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.UnitPrice")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("OrderHistory.RowAmount")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_57, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.rowNumber
                      }, [
                        _createElementVNode("td", null, _toDisplayString(row.name), 1),
                        (_ctx.isContract)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_58))
                          : _createCommentVNode("", true),
                        (_ctx.isReseller)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(row.productSize), 1))
                          : _createCommentVNode("", true),
                        (!(_ctx.isContract || _ctx.isReseller))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_60))
                          : _createCommentVNode("", true),
                        (row.isBulk)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(row.qtyOrdered / 10), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(row.qtyOrdered), 1)),
                        (row.isBulk)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString((row.unitPrice * 10) + " SEK"), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(row.unitPriceFormatted), 1)),
                        _createElementVNode("td", null, _toDisplayString(row.rowAmountFormatted), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tr", _hoisted_65, [
                    _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.order.info.find(infoType => infoType.code =="orderComment")?.value), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("OrderHistory.TotalWithoutVat")) + ":", 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.order.orderTotalExVatFormatted), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_67, [
                    _hoisted_68,
                    _hoisted_69,
                    _hoisted_70,
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("OrderHistory.TotalWithVat")) + ":", 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.order.orderTotalIncVatFormatted), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideOrder && _ctx.hideOrder(...args))),
                          class: "button--small button--primary"
                        }, _toDisplayString(_ctx.$t("Common.Back")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderAgain(_ctx.order))),
                          class: "button--small button--primary"
                        }, _toDisplayString(_ctx.$t("OrderHistory.OrderAgain")), 1)
                      ])
                    ]),
                    _hoisted_72,
                    _hoisted_73,
                    _hoisted_74,
                    _hoisted_75
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("OrderHistory.OrderDate")), 1),
                      _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$filters.formatDate(_ctx.order.orderDate)), 1)
                    ]),
                    (_ctx.isReseller || _ctx.isContract)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("OrderHistory.Recipient")), 1),
                          (_ctx.isContract)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_ctx.order.sellTo.company.name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isReseller)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.order.shipTo.customer.firstName + " " +
                _ctx.order.shipTo.customer.lastName), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isContract || _ctx.isReseller)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$t("OrderHistory.City")), 1),
                          _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.order.shipTo.address.city), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("OrderHistory.Number")), 1),
                      _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.order.orderNo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t("OrderHistory.Status")), 1),
                      _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.$t("OrderStatus." + _ctx.order.status)), 1)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card-container",
                    key: row.rowNumber
                  }, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t("OrderHistory.ProductOrder")), 1),
                        _createElementVNode("div", _hoisted_98, _toDisplayString(row.name), 1)
                      ]),
                      (_ctx.isReseller && row.productSize.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t("OrderHistory.ProductSize")), 1),
                            _createElementVNode("div", _hoisted_101, _toDisplayString(row.productSize), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (row.isBulk)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.$t("OrderHistory.Amount")), 1),
                            _createElementVNode("div", _hoisted_104, _toDisplayString(row.qtyOrdered / 10), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("OrderHistory.Amount")), 1),
                            _createElementVNode("div", _hoisted_107, _toDisplayString(row.qtyOrdered), 1)
                          ])),
                      (row.isBulk)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$t("OrderHistory.UnitPrice")), 1),
                            _createElementVNode("div", _hoisted_110, _toDisplayString((row.unitPrice * 10) + " SEK"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.$t("OrderHistory.UnitPrice")), 1),
                            _createElementVNode("div", _hoisted_113, _toDisplayString(row.unitPriceFormatted), 1)
                          ])),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t("OrderHistory.RowAmount")), 1),
                        _createElementVNode("div", _hoisted_116, _toDisplayString(row.rowAmountFormatted), 1)
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_117, [
                  (_ctx.order.info.find(infoType => infoType.code == 'orderComment'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.$t("OrderHistory.Message")), 1),
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.order.info.find(infoType => infoType.code == 'orderComment')?.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("OrderHistory.TotalWithoutVat")) + ": " + _toDisplayString(_ctx.order.orderTotalExVatFormatted), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("OrderHistory.TotalWithVat")) + ": " + _toDisplayString(_ctx.order.orderTotalIncVatFormatted), 1),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideOrder && _ctx.hideOrder(...args))),
                      class: "button--small button--primary"
                    }, _toDisplayString(_ctx.$t("Common.Back")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.orderAgain(_ctx.order))),
                      class: "button--small button--primary"
                    }, _toDisplayString(_ctx.$t("OrderHistory.OrderAgain")), 1)
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_124))
}